import React from 'react';
import { useTranslation } from 'react-i18next';
import { sectionClassName } from './HomeVideosSection';

/**
 * Loading placeholder that reserves roughly the section's height (header,
 * one featured card and three rows) so the page does not jump when the
 * videos arrive.
 */
export default function HomeVideosSkeleton() {
  const { t } = useTranslation();

  return (
    <section className={sectionClassName} aria-busy="true" data-testid="home-videos-skeleton">
      <span className="sr-only" role="status">{t('home_videos.section.loading')}</span>
      <div className="animate-pulse" aria-hidden="true">
        <div className="h-6 w-72 max-w-full rounded bg-cs-gray-100" />
        <div className="mt-4 h-5 w-full max-w-2xl rounded bg-cs-gray-100" />
        <div className="mt-4 grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] gap-3">
          <div className="rounded-[15px] bg-cs-gray-100 p-3">
            <div className="[aspect-ratio:16/9] rounded-[10px] bg-cs-gray-200" />
            <div className="h-24" />
          </div>
          <div className="flex flex-col gap-3">
            <div className="h-24 rounded-[15px] bg-cs-gray-100" />
            <div className="h-24 rounded-[15px] bg-cs-gray-100" />
            <div className="h-24 rounded-[15px] bg-cs-gray-100" />
          </div>
        </div>
      </div>
    </section>
  );
}
